import { Moon, Sun } from "lucide-react";
import { Button } from "@web/components/ui/button";
import type { ReaderPreference } from "../../api";

export function ThemeToggleButton({
  theme,
  variant = "ghost",
  onToggle,
}: {
  theme: ReaderPreference["theme"];
  variant?: "ghost" | "outline";
  onToggle: () => void;
}) {
  return (
    <Button type="button" size="icon-sm" variant={variant} aria-label="切换主题" title="切换主题" onClick={onToggle}>
      {theme === "dark" ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </Button>
  );
}
